import axios from 'axios';

import {
  ICreateCannedResponsePrm,
  IUpdateCannedResponsePrm,
  IRemoveCannedResponsePrm,
  ICustomerDataPrm,
  ICallback,
  ICustomerCallback,
} from '../interfaces';
import { config } from '../config';

export const apiHelper = async (prm: any, method: string) => {
  try {
    const { data, status } = await axios.post(
      `${config.apiUrl}/${method}`,
      prm,
      {
        headers: {
          'X-Api-Key': config.apiKey,
        },
      }
    );
    if (status !== 200) {
      throw new Error('Something went wrong');
    }
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getCannedResponses = async (
  username: string,
  callback: ICallback
) => {
  const res = await apiHelper({ username }, 'getCannedReplies');
  window.localStorage.setItem('canned_responses', JSON.stringify(res));
  window.localStorage.setItem('last_check_time', `${+new Date()}`);
  if (callback) {
    callback.setCannedResponses(res.canned_replies);
    callback.setShortcuts(res.shortcuts);
  }
};

export const checkCannedResponses = async (
  username: string,
  callback: ICallback
) => {
  const { last_update } = await apiHelper(
    { username, responceData: 'last_update' },
    'getCannedReplies'
  );
  const currentData = window.localStorage.getItem('canned_responses');
  if (!currentData || last_update !== JSON.parse(currentData).last_update) {
    return getCannedResponses(username, callback);
  }
  window.localStorage.setItem('last_check_time', `${+new Date()}`);
};

export const createCannedResponse = async (
  prm: ICreateCannedResponsePrm,
  callback: ICallback
) => {
  await apiHelper({ ...prm }, 'createCannedReply');
  await getCannedResponses(prm.user.username, callback);
};

export const updateCannedResponse = async (
  prm: IUpdateCannedResponsePrm,
  callback: ICallback
) => {
  await apiHelper({ ...prm }, 'updateCannedReply');
  await getCannedResponses(prm.user.username, callback);
};

export const removeCannedResponse = async (
  prm: IRemoveCannedResponsePrm,
  callback: ICallback
) => {
  await apiHelper({ ...prm }, 'removeCannedReply');
  await getCannedResponses(prm.username, callback);
};

export const getListSecurityProfiles = async (instanceId: string) => {
  return await apiHelper(
    { InstanceId: instanceId, MaxResults: 1000 },
    `listSecurityProfiles?Region=${config.region}`
  );
};

export const getListUsers = async (instanceId: string) => {
  return await apiHelper(
    { InstanceId: instanceId, MaxResults: 1000 },
    `listUsers?Region=${config.region}`
  );
};

export const getCustomerData = async (
  prm: ICustomerDataPrm,
  callback: ICustomerCallback
) => {
  try {
    const { contact, instanceId } = prm;
    const { setContact } = callback;
    const attributeMap = contact.getAttributes();
    const phone =
      attributeMap.Phone?.value ||
      contact.getActiveInitialConnection()?.getEndpoint().phoneNumber ||
      '';
    const email = attributeMap.Email?.value || '';
    const FirstName = attributeMap.FirstName?.value || '';
    const LastName = attributeMap.LastName?.value || '';

    if (!phone && !email) return;

    const res = await apiHelper({ email, phone }, 'getCustomerData');

    if (res.success) {
      const data = res.body;

      if (data) {
        const newAttributes = {
          Email: email || data?.email || '',
          Phone: phone || '',
          User_id: data.userId?.toString() || '',
          IterableData: JSON.stringify(data?.events || {}),
          FirstName: FirstName || data?.first_name,
          LastName: LastName || data?.last_name,
        };

        const params = {
          Attributes: newAttributes,
          InitialContactId: contact.getContactId(),
          InstanceId: instanceId,
        };

        await updateContactAttributes(params);
        contact.onRefresh(function (contact) {
          setContact((prev) => {
            if (prev?.contactId === contact.contactId) {
              return contact;
            }
            return prev;
          });
        });
      }
    }
  } catch (error) {}
};

export const updateContactAttributes = async (prm: any) => {
  await apiHelper({ ...prm }, 'updateContactAttributes');
};

export const getUserInfo = async (
  instanceId: string,
  username: string,
  setUserInfo: any
) => {
  try {
    const res = await Promise.all([
      getListSecurityProfiles(instanceId),
      getListUsers(instanceId),
    ]);
    const { Id } = res[1].body.UserSummaryList.find(
      (i: any) => i.Username === username
    );
  
    const info = await apiHelper(
      { InstanceId: instanceId, UserId: Id },
      `describeUser?Region=${config.region}`
    );
  
    setUserInfo({
      id: info.body.User.Id,
      user: {
        username,
        first_name: info.body.User.IdentityInfo.FirstName,
        last_name: info.body.User.IdentityInfo.LastName,
      },
      groups: info.body.User.SecurityProfileIds.map((i: any) => {
        const available_profile = res[0].body.SecurityProfileSummaryList.find(
          (el: any) => el.Id === i
        );
        if (available_profile) {
          return {
            id: available_profile.Id,
            name: available_profile.Name,
          };
        }
        return null;
      }),
    });
  } catch (error) {
    console.log('123 error', error);
  }
  
};
